import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';

export const PreferencesStyles = styled(OnboardingPage)`
  ion-content {
    &::part(scroll) {
      margin-top: 4px;
    }
  }
`;
